// Prevent default browser dragging behavior on buttons and links (fix for Firefox)
document.addEventListener("dragstart", (e) => {
    if (e.target instanceof Element && e.target.closest("button, a")) {
        e.preventDefault();
    }
});